import { create } from 'zustand';
import { Song } from '@/types/song';

interface PlayerState {
  // Oynatıcı durumu
  isPlaying: boolean;
  currentSong: Song | null;
  volume: number;
  progress: number;
  duration: number;
  isPlayerVisible: boolean;
  
  // Eylemler
  playSong: (song: Song) => void;
  pauseSong: () => void;
  resumeSong: () => void;
  stopSong: () => void;
  setVolume: (volume: number) => void;
  setProgress: (progress: number) => void;
  setDuration: (duration: number) => void;
  hidePlayer: () => void;
  showPlayer: () => void;
  
  // Gelişmiş kontroller
  seekToPosition: (position: number) => void;
  skipBackward: (seconds: number) => void;  // F7 kısayolu için
  skipToEnd: (seconds: number) => void;     // F9 kısayolu için
}

export const usePlayerStore = create<PlayerState>((set, get) => ({
  // Başlangıç durumu
  isPlaying: false,
  currentSong: null,
  volume: 0.5,
  progress: 0,
  duration: 0,
  isPlayerVisible: true,
  
  // Eylemler
  playSong: (song: Song) => set({ 
    currentSong: song, 
    isPlaying: true, 
    progress: 0,
    isPlayerVisible: true
  }),
  
  pauseSong: () => set({ 
    isPlaying: false 
  }),
  
  resumeSong: () => set({ 
    isPlaying: true 
  }),
  
  stopSong: () => set({ 
    isPlaying: false, 
    currentSong: null, 
    progress: 0 
  }),
  
  setVolume: (volume: number) => set({ 
    volume: Math.max(0, Math.min(1, volume)) 
  }),
  
  setProgress: (progress: number) => set({ 
    progress 
  }),
  
  setDuration: (duration: number) => set({ 
    duration 
  }),
  
  hidePlayer: () => set({ 
    isPlayerVisible: false,
    isPlaying: false,
    currentSong: null,
    progress: 0,
    duration: 0
  }),
  
  showPlayer: () => set({ 
    isPlayerVisible: true 
  }),
  
  // Gelişmiş kontroller
  seekToPosition: (position: number) => set({
    progress: Math.max(0, Math.min(position, get().duration))
  }),
  
  skipBackward: (seconds: number = 10) => {
    const { progress } = get();
    set({ progress: Math.max(0, progress - seconds) });
  },
  
  skipToEnd: (seconds: number = 20) => {
    const { duration } = get();
    if (duration > seconds) {
      set({ progress: duration - seconds });
    }
  }
}));
